export const classes = {
  logo: 'max-h-12 w-auto max-w-[150px] object-contain',
  defaultLogo: 'text-[#002155] dark:text-white',
};
